import { render, staticRenderFns } from "./ManageSettings.vue?vue&type=template&id=5656e658&scoped=true&"
import script from "./ManageSettings.vue?vue&type=script&lang=ts&"
export * from "./ManageSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ManageSettings.vue?vue&type=style&index=0&id=5656e658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5656e658",
  null
  
)

export default component.exports